import * as types from "../../../_constants/types";

export default (state = { loading: false }, action) => {
    switch (action.type) {
        case types.AUTH_TOKEN_FETCHING:
            return { loading: true };

        case types.AUTH_TOKEN_FETCHING_COMPLETED:
            return { loading: false };

        case types.AUTH_TOKEN_FETCHING_CANCELLED:
            if (!state.loading) {
                return { loading: false, err: action.err };
            }
            return state;

        case types.AUTH_TOKEN_FETCHING_FAILED:
            return { loading: false, err: action.err };

        default:
            return state;
    }
};
